import React from 'react';
import Logout from '../components/authentication/Logout';

const PageUitloggen: React.FC = () => (
  <div>
    <header className="page-header container">
      <h1>Uitloggen</h1>
      <p>Je wordt automatisch uitgelogd! Een moment geduld aub...</p>
      <Logout />
    </header>
  </div>
);

export default PageUitloggen;